<template>
  <div class="flex w-[450px] m-5 gap-5">
    <div class="flex flex-col p-5 bg-white rounded-lg">
      <div class="flex flex-col items-center gap-4">
        <div class="w-40 h-40">
          <img :src="defaultImage" alt="Pet Image" class="object-cover w-full h-full rounded-lg">
        </div>
      </div>
    </div>
    <div class="flex flex-1 flex-col gap-3 p-5 bg-white rounded-lg">
      <PetIdentityFields v-model:name="name" v-model:category-id="selectedCategory" />
      <div class="flex flex-col flex-1 justify-end">
        <Button class="bg-primary" :disabled="creating || !selectedCategory" @click="create">
          <Save :class="creating ? 'animate-spin' : ''" />
          Ajouter
        </Button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>

import {Pet} from "@/customer/interfaces/Pet";
import {ref} from "vue";
import {petApi} from "@/container";
import defaultImage from '@/assets/images/pets.jpg';
import {Button} from "@/core/components/ui/button";
import {Save} from "@lucide/vue";
import Customer from "@/customer/interfaces/Customer";
import PetIdentityFields from "@/customer/components/customer-beneficiary/PetIdentityFields.vue";

const props = defineProps<{
    customer: Customer;
}>();

const emit = defineEmits<{
    (e: 'create', pet: Pet): void;
}>();

const selectedCategory = ref<string>();
const name = ref<string>();
const creating = ref<boolean>(false);

const create = async () => {
    creating.value = true;

    const createdPet = await petApi().create({
        name: name.value,
        category_id: Number(selectedCategory.value),
        customer_id: props.customer.id
    });

    creating.value = false;

    emit('create', createdPet);
};

</script>
